import { THEME_PARAM } from './theme/theme';

// The params worth keeping when a page builds its own navigation target (so
// full ?search can't be carried verbatim): signup origin and the pinned
// palette. Auth pages carry these across their internal links, so a pinned
// theme survives login <-> signup hops.
export function carriedAuthParams(
  searchParams: URLSearchParams
): URLSearchParams {
  const carried = new URLSearchParams();
  for (const param of ['s', THEME_PARAM]) {
    const value = searchParams.get(param);
    if (value !== null) {
      carried.set(param, value);
    }
  }
  return carried;
}
